import { NgModule } from '@angular/core';
import {ConfirmationDialogComponent} from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import {MatIconModule} from '@angular/material/icon';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import { ConfigurationModeConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/configuration-mode-confirmation-dialog/configuration-mode-confirmation-dialog.component';

@NgModule({
  imports: [MatIconModule, MatDialogModule, MatButtonModule],
  declarations: [
    ConfirmationDialogComponent,
    ConfigurationModeConfirmationDialogComponent
  ],
  exports: [
    ConfirmationDialogComponent,
    ConfigurationModeConfirmationDialogComponent

  ],
  providers: []
})
export class ConfirmationDialogModule { }
